import { createSlice } from "@reduxjs/toolkit";

const expenseSlice = createSlice({
  name: "expenses",
  initialState: {
    isFetching: false,
    expenses: [],
    error: []
  },
  reducers: {
    statusExpenseStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusExpenseSuccess: (state, action) => {
      state.isFetching = false
      state.expenses = action.payload
      state.error = []
    },
    statusExpenseFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusExpenseStart,
  statusExpenseSuccess,
  statusExpenseFailure 
} = expenseSlice.actions

export default expenseSlice.reducer